const inlineStyles = {
    point: {
        fill: 'transparent',
    },
};
export default inlineStyles;
